import {
  Component,
  EventEmitter,
  Inject,
  Input,
  model,
  OnInit,
  Output,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SearchContactTypeModel } from '../../../core/models/contact-type.model'
import { MatButton } from '@angular/material/button'
import {
  MatFormField,
  MatFormFieldModule,
  MatLabel,
} from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'

import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog'

import { MatIconModule } from '@angular/material/icon'
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import {
  MatDatepicker,
  MatDatepickerModule,
  MatDateRangePicker,
} from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatTableModule } from '@angular/material/table'
import { MatPaginator } from '@angular/material/paginator'
import { VehicleService } from '../../../core/services/vehicle/vehicle/vehicle.service'
import { ScheduleVehicleService } from '../../../core/services/schedule/schedule-vehicle/schedule-vehicle.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SelectionModel } from '@angular/cdk/collections'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatTooltipModule } from '@angular/material/tooltip'

@Component({
  selector: 'app-schedule-vehicle',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatDatepicker,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatPaginator,
    MatProgressSpinner,
    MatCheckboxModule,
    MatTooltipModule,
    MatProgressBar,
  ],
  templateUrl: './schedule-vehicle.component.html',
  styleUrl: './schedule-vehicle.component.scss',
  standalone: true,
})
export class ScheduleVehicleComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private vehicleService: VehicleService,
    private scheduleVehicleService: ScheduleVehicleService,
    private snackbar: SnackbarCustomService,
  ) { }

  selectionActive: any = false
  selection = new SelectionModel<any>(false, [])
  form!: FormGroup
  itemsList: any[] = []
  typeSearch: any
  loading: boolean = false
  listTypeVehicle: any[] = []
  listSearch: any = [
    {
      value: 'modelo',
      description: 'Modelo',
    },
    {
      value: 'placa',
      description: 'Placa',
    },
    {
      value: 'descricaoTipoVeiculo',
      description: 'Tipo Veiculo',
    },
  ]

  @Input() dataVehicle: any
  @Input() view: any
  @Output() checkboxChange = new EventEmitter<any>()
  @Output() response = new EventEmitter<any>()
  @Output() responseIndex = new EventEmitter<any>()
  editIndex: number | null = null
  editAgendaItem: any = null
  page: number = 1
  rows: number = 10
  numberRows: number = 0
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  displayedColumns: string[] = [
    'select',
    'typeVehicle',
    'plate',
    'model',
    // 'action',
  ]
  columns: any[] = [
    { keyColumn: 'select', key: 'selectItem', description: 'Selecionar' },
    {
      keyColumn: 'typeVehicle',
      key: 'descricaoTipoVeiculo',
      description: 'Tipo Veículo',
    },
    { keyColumn: 'plate', key: 'placa', description: 'Placa' },
    { keyColumn: 'model', key: 'modelo', description: 'Modelo' },
    // {
    //   keyColumn: 'action',
    //   key: { edit: false, delete: false },
    //   description: 'Ações',
    // },
  ]

  ngOnInit(): void {
    this.createForm()
    console.log('Dados de veiculo: ', this.dataVehicle.item)
    if (this.dataVehicle.viewMode) {
      this.listVehiclesByOs()
    } else {
      this.listVehicles()
    }
    if (this.dataVehicle.item.id) {
      this.fillForm()
    } else {
      this.createModal()
    }

    if (this.selection.selected.length > 0) {
      this.selectionActive = true
    } else {
      this.selectionActive = false
    }
    console.log('Visualizar: ', this.view)
  }

  onSelectRow(element: any, checked: boolean) {

    this.checkboxChange.emit(element)
    if (checked) {
      this.selectionActive = true
      this.selection.toggle(element)
      this.form.patchValue({
        typeVehicle: element.descricaoTipoVeiculo,
        plate: element.placa,
        model: element.modelo,
      })
      const item = {
        veiculoId: this.selection.selected[0].id,
        dataInicio: this.data.item.dataInicio,
        horaInicio: this.data.item.horaInicio, // Formata a hora de início
        dataFinal: this.data.item.dataFinal,
        horaFinal: this.dataVehicle.item.horaFinal,    // Formata a hora final
        ordemServicoId: this.dataVehicle.item.codigoOs
      }
      const itemEdit = {
        id: this.dataVehicle.item.agendaVeiculoId,
        veiculoId: this.selection.selected[0].id,
        dataInicio: this.data.item.dataInicio,
        horaInicio: this.data.item.horaInicio, // Formata a hora de início
        dataFinal: this.data.item.dataFinal,
        horaFinal: this.dataVehicle.item.horaFinal,    // Formata a hora final
        ordemServicoId: this.dataVehicle.item.codigoOs
      }

      if (this.dataVehicle.item.status === 5) {
        this.response.emit(itemEdit)
      } else {
        this.response.emit(item)
      }
    } else {
      this.selectionActive = false
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      typeSearch: ['placa', [Validators.required]],
      search: ['', [Validators.required]],
      typeVehicle: ['', [Validators.required]],
      plate: ['', [Validators.required]],
      model: ['', [Validators.required]],
      veiculo: ['', [Validators.required]],
      select: ['', [Validators.required]],
    })
  }

  searchItem() {
    this.loading = true
    const selectedIds = this.selection.selected.map((item) => item.placa)

    const type = this.form.get('typeSearch')?.value
    let item = {}
    if (type === 'modelo') {
      item = {
        modelo: this.form.get('search')?.value,
        placa: '',
        descricaoTipoVeiculo: '',
        isFrota: '',
      }
    } else if (type === 'placa') {
      item = {
        modelo: '',
        placa: this.form.get('search')?.value,
        descricaoTipoVeiculo: '',
        isFrota: '',
      }
    } else if (type === 'descricaoTipoVeiculo') {
      item = {
        modelo: '',
        placa: '',
        descricaoTipoVeiculo: this.form.get('search')?.value,
        isFrota: '',
      }
    }
    console.log(item)

    this.vehicleService
      .searchPagedVehicle(this.page, this.rows, item)
      .subscribe({
        next: (res) => {
          this.itemsList = res.data
          // this.snackbar.success(res.message)
          this.loading = false
          this.restoreSelection(this.itemsList)
        },
        error: (err) => {
          this.snackbar.error(err.message)
          this.loading = false
        },
      })
  }

  private restoreSelection(newList: any[]) {
    // Supondo que cada item tem um id único chamado 'id'
    if (!newList) return
    const selectedIds = this.selection.selected.map((item) => item.id)
    newList.forEach((item) => {
      if (selectedIds.includes(item.id)) {
        this.selection.select(item)
      }
    })
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length
    const numRows = this.itemsList.length
    return numSelected === numRows
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.itemsList.forEach((row) => this.selection.select(row))
  }

  next() {
    this.editIndex = null
    this.responseIndex.emit(1)
  }

  editItem(item: any) {
    this.editIndex = this.itemsList.findIndex(
      (i) =>
        i.date === item.date &&
        i.startDate === item.startDate &&
        i.endDate === item.endDate,
    )
    this.editAgendaItem = { ...item }
    this.form.patchValue({
      date: item.date,
      startHours: item.startDate,
      endHours: item.endDate,
    })
  }

  deleteItem(item: any) {
    this.loading = true
    this.scheduleVehicleService.deleteAgendaVeiculo(item.id).subscribe({
      next: () => {
        this.snackbar.success('Desvinculado com sucesso')
        this.loading = false
        this.listVehiclesByOs()
      },
      error: (err) => {
        console.error(
          'Ocorreu um erro ao deletar o agendamento do motorista',
          err,
        )
      },
    })
  }

  listVehicles() {
    const idOs = { ordemServicoId: this.data.item.codigoOs }
    this.loading = true
    this.scheduleVehicleService
      .listPagedFreeVehicles(this.page, this.rows, idOs)
      .subscribe({
        next: (res) => {
          this.itemsList = res.data
          this.numberRows = res.data.totalItens
          this.listVehiclesIsPresent()
          this.loading = false
        },
      })
  }

  listVehiclesByOs() {
    this.loading = true
    const idOs = { ordemServicoId: this.data.item.codigoOs }
    this.scheduleVehicleService
      .listPagedAgendaVeiculoByOs(this.page, this.rows, idOs)
      .subscribe({
        next: (res) => {
          if (res.data === null) return
          this.itemsList = res.data
          this.numberRows = res.data.totalItens
          this.selection.clear()
          this.itemsList.forEach((item) => this.selection.select(item))
          this.loading = false
        },
        error: (err) => {
          console.error(err.message)
        },
      })
  }

  listVehiclesIsPresent() {
    const idOs = { ordemServicoId: this.data.item.codigoOs }
    this.scheduleVehicleService
      .listPagedAgendaVeiculoByOs(this.page, this.rows, idOs)
      .subscribe({
        next: (res) => {
          if (res.data === null) return

          const item = res.data[0]
          this.itemsList.forEach((itemList) => {
            if (itemList.id === item.id) {
              this.checkboxChange.emit(item)
              this.selection.select(itemList)
              this.selectionActive = true
            }
          })
        },
        error: (err) => {
          console.error(err.message)
        },
      })
  }

  saveEditAgendaItem() {
    if (this.editIndex !== null) {
      const formValue = this.form.value
      this.itemsList[this.editIndex] = {
        date: formValue.date
          ? new Date(formValue.date).toLocaleDateString('pt-BR')
          : '',
        startDate: formValue.startHours,
        endDate: formValue.endHours,
      }
      this.itemsList = [...this.itemsList]
      this.editIndex = null
      this.editAgendaItem = null

      this.form.patchValue({
        date: '',
        startHours: '',
        endHours: '',
      })
    }
  }

  reateForm(): void {
    this.form = this.formBuilder.group({
      date: ['', Validators.required],
      startHours: ['', Validators.required],
      endHours: ['', Validators.required],
    })
  }

  resetForm() {
    this.form.get('search')?.setValue('')

    const item = {
      modelo: '',
      placa: '',
      descricaoTipoVeiculo: '',
      isFrota: '',
    }

    this.vehicleService
      .searchPagedVehicle(this.page, this.rows, item)
      .subscribe({
        next: (res) => {
          this.itemsList = res.data
          this.snackbar.success(res.message)
          this.loading = false

          this.restoreSelection(this.itemsList)
        },
      })
  }

  cancel() {
    this.editIndex = null
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }


  createModal() {
    console.log('Create model')
    this.form.patchValue({
      model: this.dataVehicle.item.veiculoModelo,
      typeVehicle: this.dataVehicle.item.descricaoTipoVeiculo,
      plate: this.dataVehicle.item.placa,
    })
  }

  fillForm() {
    console.log('status: ', this.dataVehicle.viewMode)

    this.scheduleVehicleService
      .getAgendaVeiculobyId(this.dataVehicle.item.id)
      .subscribe({
        next: (res) => {
          this.form.patchValue({
            model: this.dataVehicle.veiculoModelo,
            typeVehicle: this.dataVehicle.descricaoTipoVeiculo,
            plate: this.dataVehicle.placa,
            veiculo: res.data.veiculoId,
          })
        },
        error: (err) => {
          console.error('Ocorreu um erro ao listar os motoristas', err)
        },
      })
  }
}
